


import { useState, useEffect, useRef } from "react";
import MKTypography from "components/MKTypography"; 
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
 
import Tooltip from "@mui/material/Tooltip"; 
import Card from "@mui/material/Card";
 
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";
import Divider from "@mui/material/Divider";
 
import MKBadge from "components/MKBadge";
import Dropdowns from "components/AppKey/Dropdowns";
import { appAuth } from "../../contexts/AppContext"
import { useAuth } from "../../contexts/AuthContext"
import { startAuthentication} from '@simplewebauthn/browser';


import AppActionDetail from "./AppActionDetail";


export default function AppAction({app}) { 

    const renderRef = useRef(false)
 
    const {verify, verifyComplete} = useAuth()
    const {getAppAction, createAppAction, updateAppAction, deleteAppAction, getAppGroup} = appAuth()
    const [message, setMessage] = useState("")
    const [error, setErrorMessage] = useState("")

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [total, setTotal] = useState();
    
    const [filter, setFilter] = useState({appId:app.appId, type:"all",  limit:25, offset: 0})
    const [search, setSearch] = useState("")
    const [data, setData] = useState({appId:app.appId})

    const [actionData, setActionData] = useState([]);
    const [actionDataRender, setActionDataRender] = useState([]);
    const [groupData, setGroupData] = useState([]);
    const [actionToEdit, setActionToEdit] = useState({});

    const [modalState, setModalState] = useState({
        showCreateAction:false,
        showEditAction:false,
        showDeleteAction:false,
        item:{}, 
    });

    const actionTableHeader = [
        { id: "actionId", name: "action Id", align: "center" }, 
        { id: "name",  name: "name", align: "center" },  
        { id: "ceremony", name: "ceremony", align: "center" }, 
        { id: "status", name: "status", align: "center" }, 
        { id: "executed", name: "executed", align: "center" }, 
        { id: "createdAt", name: "created", align: "center" }, 
        { id: "control", name: "control", align: "center" },
    ]

    useEffect(() => {

      
        async function getActions() {
            console.log("getActions useEffect appId ", app.appId);

            setActionData(prevItems => { 
                return [];
            }); 
    
            setActionDataRender(prevItems => { 
                return [];
            });  
    
            setFilter({
                ...filter,
                ["search"]: search
            });
    
            let groups = await getAppGroup({appId:app.appId, limit:250, offset: 0});
           
            setGroupData(groups.data)
    
            let result = await getAppAction(filter)
    
            setTotal(0)
    
            if (!result || !result.data) return
    
            setTotal(result.total || 0)
    
            for (let index = 0; index < result.data.length; index++) {
                
                let element = makeRecord(result.data[index]); 
                element.number = index + 1 
              
                setActionData(prevItems => { 
                    return [...prevItems, element];
                });  
    
                setActionDataRender(prevItems => { 
                    return [...prevItems, element];
                });  
                
               
            } 
        } 

        if (renderRef.current === false){

            getActions()

            return () => { 
                renderRef.current = true
                console.log("AppAction render clean up. ")
            }
        }

    }, [])

    
    
    const formatDate = (dateString) => {
        if(!dateString) return "NA"
        const options = { year: "2-digit", month: "2-digit", day: "2-digit", hour: 'numeric', hour12: true}
        return new Date(dateString).toLocaleDateString(undefined, options)
    }

    const makeRecord = (item) => { 
        item.executed = formatDate(item.executed)
        item.createdAt = formatDate(item.createdAt)
        item.updatedAt = formatDate(item.updatedAt) 
        item.hide = false  
        return item
          
    }


    
    
    
    const onChangeInput = (evt) => { 

        setData({
            ...data,
            [evt.target.name]: evt.target.value,
        });
    }


    const handleChangeRowsPerPage = (value) => {

        console.log("handleChangeRowsPerPage newPage ", value);
        setFilter({
            ...filter,
            ["limit"]: value,
            ["offset"] : 1
        });

        //setTotalPage( Math.ceil(total/value)) 

        setRowsPerPage(value);
        setPage(1); 
       
    };

    const handleChangePage = (event, newPage) => {
        console.log("handleChangePage newPage ", newPage); 
        setPage(newPage);
        setFilter({
            ...filter,
            ["offset"]: newPage
        });

        
    };

    const handleCreateAction = async () => {
        setErrorMessage("")
        setMessage("") 

        if(!data.name) {
            setErrorMessage("Please enter action field") 
            return;
        }
      

        let result = await createAppAction(data)
        
        if (result && result.error) {
            setErrorMessage(result.error.message) 
            return;
        } 
        let action = makeRecord(result)
        action.number = actionData.length + 1
        
        setActionData(prevItems => { 
            return [action, ...prevItems];
        });  

        setActionDataRender(prevItems => { 
            return [action, ...prevItems];
        });  
        
        
        toggleCreateActionModal()
    }

    
    const toggleCreateActionModal = () => { 
        setModalState({ ...modalState, ["showCreateAction"]:!modalState.showCreateAction })   
    }

    
    const toggleEditActionModal = (item) => {
        setActionToEdit(item)
    }

    const toggleDeleteActionModal = (item) => {
        setModalState({ ...modalState, ["showDeleteAction"]:!modalState.showDeleteAction, item:item })   
    }

    const updateActionStatusHandler = async (action, status) => {   
       
        let data = JSON.parse(JSON.stringify(action));
        data.status = status
        let result = await updateAppAction(data);

        if(result) { 
            action.status = status
            // setActionData(actionData.map(item => { 
            //     if (item.actionId === action.actionId){ 
            //         return action 
            //     } 
            //     else return item
            // })); 

            
            // setActionDataRender( actionDataRender.map(item => { 
            //     if (item.actionId === action.actionId){ 
            //         return action 
            //     } 
            //     else return item
            // })); 

        }
    }

    const verifyPasskey = async () => {
        try { 
            
            let challenge = await verify();
            if(challenge.error) {
                return;
            }

            let asseResp = await startAuthentication({ optionsJSON: challenge });
            let authn = await verifyComplete(asseResp);
            if (authn.error) {
                setMessage(`Whoop! ${authn.error.message}.`, "error")
                return false
            }

            return true;
        } catch (error) {
            return false;
        }
    }
    
    const deleteAppActionHandler = async () => {

       
        
        let passedVerify = await verifyPasskey();
        if(!passedVerify) return;
        
        
        let result = await deleteAppAction(modalState.item);
        if(result) {

            setActionData(
                actionData.filter(data => data.actionId != modalState.item.actionId)
            );  
            setActionDataRender(
                actionDataRender.filter(data => data.actionId != modalState.item.actionId)
            ); 

            toggleDeleteActionModal() 
        }
    }

    const onKeyEnterDown = (event) => {
        if(event.keyCode == 13) {
            handleCreateAction()
        }
    }


    
    const getRandomKey = (index) => {
        return  `${index}${Date.now()}`
    }

    const actionUpdateHandler = (action) => {

        console.log("actionUpdateHandler action ", action)

        let result = updateAppAction(action);
        if(result){ 
            
            setActionData(actionData.map(item => { 
                if (item.actionId === action.actionId){ 
                    return action 
                } 
                else return item
            })); 

            
            setActionDataRender( actionDataRender.map(item => { 
                if (item.actionId === action.actionId){ 
                    return action 
                } 
                else return item
            })); 


            setActionToEdit({})
        }


    }

    const handleOnCloseEditAction = (action) => {
        if(action){
            setActionData(actionData.map(item => { 
                if (item.actionId === action.actionId){ 
                    return action 
                } 
                else return item
            })); 

            
            setActionDataRender( actionDataRender.map(item => { 
                if (item.actionId === action.actionId){ 
                    return action 
                } 
                else return item
            })); 


            setActionToEdit({})
        }
    }


    return(
        <MKBox p={2}>
        { actionToEdit.actionId != null ? 
        <MKBox> 
            
            <AppActionDetail action = {actionToEdit} app= {app} allGroups = {groupData} onClose={ (data) => handleOnCloseEditAction(data)}  onSubmit={ (data) => actionUpdateHandler(data)} /> 

        </MKBox> 
            :
        
        <MKBox>
           
            <MKTypography variant="h5">Application Actions</MKTypography>

                <MKBox display="flex" justifyContent="space-between"> 
                    
                    <MKBox alignItems="center" justifyContent="left" display="flex">

                        <MKTypography variant="body2" color="text">  Show:  </MKTypography> 
                        <Dropdowns items={[25,  100, 150]} defaultValue = {rowsPerPage}  onChange={handleChangeRowsPerPage}   /> 
                        <MKTypography variant="body2" color="text"> entries  </MKTypography> 

                        <MKBox px={3}> 
                            <MKTypography variant="body2" color="text"> Total Record: {total}  </MKTypography>
                        </MKBox>
                    </MKBox>

                   
                    <Tooltip title="Add Action" placement="top">
                        <MKButton variant="outlined" color="info" onClick={toggleCreateActionModal} px={2} iconOnly> <Icon sx={{ mr: 1 }}>new_label</Icon> </MKButton>
                    </Tooltip>
                </MKBox>

                {actionDataRender.length > 0 ? <TableContainer sx={{ maxHeight: 650 }}>
                <Table responsive="sm">
                    <thead>
                    <TableRow key={getRandomKey("group")}>
                    {actionTableHeader.map((column) => (
                        <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className="colunmHeader"
                        >
                        {column.name}
                        </TableCell>
                    ))}
                    </TableRow>
                    </thead>
                <TableBody>
                    {actionDataRender
                        //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((action) => {
                            return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={action._id}>
                                {actionTableHeader.map((column) => {

                                    let value = action[column.id];
                                    if (column.id === "ceremony") { 

                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                                <MKBox display="flex" alignItems="center" justifyContent="space-between">
                                                    {value.Authentication ? <span>Authentication</span>: ""}
                                                    {value.Registration ?  <span className="px-1">Registration</span>: ""}
                                                    {value.Group ? <span className="px-1">Group</span>: ""}
                                                </MKBox>
                                            </TableCell>
                                        );
                                    }
                                    else if (column.id === "status") { 

                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                                { value === "active" ?  <MKBadge variant="contained" badgeContent= {value} color="success" size="xs" container /> :
                                                                       <MKBadge variant="contained" badgeContent= {value} color="error" size="xs" container />
                                                }

                                            </TableCell>
                                        );
                                    }

                                    else if (column.id === "control") {
                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                                <MKBox>
                                                     
                                                    <MKButton variant="text" color="info" onClick={ () => toggleEditActionModal(action)} iconOnly px={2} ><Icon>edit</Icon></MKButton> &nbsp;
                                                    
                                                    
                                                    <MKButton  variant="text" color="error" onClick={ () => toggleDeleteActionModal(action)} iconOnly px={2}><Icon>delete</Icon></MKButton> &nbsp;
                                                    { action.status === "active" ?   
                                                        <Tooltip title="suspend this action" placement="top">
                                                        <MKButton variant="text" color="info" onClick={ () => updateActionStatusHandler(action, "suspended")} iconOnly px={2}><Icon>toggle_on</Icon></MKButton>
                                                        </Tooltip> : 
                                                        <Tooltip title="activate this action" placement="top">
                                                        <MKButton variant="text" color="error" onClick={ () => updateActionStatusHandler(action, "active")} iconOnly px={2}><Icon>toggle_off</Icon></MKButton>
                                                        </Tooltip>
                                                    }

                                                    <Tooltip title="copy action id" placement="top">  
                                                        <MKButton color="white" onClick={() => {navigator.clipboard.writeText(action.actionId)}}>
                                                            <Icon fontSize="large">copy</Icon>
                                                        </MKButton>
                                                    </Tooltip>

                                                </MKBox>   
                                            </TableCell>
                                        );
                                    }
                                    else { 


                                        return (
                                            <TableCell key={column.id} align={column.align} className="tableCell">
                                            {column.format && typeof value === 'number'
                                                ? column.format(value)
                                                : value}
                                            </TableCell>
                                        );
                                    }
                                })}
                            </TableRow>
                            );
                        })}
                </TableBody>


                </Table>
                </TableContainer>


                :
                    <MKTypography color="info" pr={4}>No Record</MKTypography>
                }

                {Math.ceil(total/rowsPerPage) > 1 &&  
                    <Grid container item xs={12} lg={5} justifyContent="center" mx="auto" py={3}> 
                        <Pagination count={Math.ceil(total/rowsPerPage)} showFirstButton showLastButton page={page} onChange={handleChangePage} />
                    </Grid>
                }


            <Modal open={modalState.showCreateAction} onClose={() => toggleCreateActionModal()} sx={{ display: "grid", placeItems: "center" }}>
                    <Slide direction="down" in={modalState.showCreateAction} timeout={300}>
                    <Grid container item xs={12} lg={5} justifyContent="center" mx="auto">
                    <Card>
                        <MKBox
                        variant="contained"
                        bgColor="primary"
                        borderRadius="lg"
                        coloredShadow="info"
                        mx={2}
                        mt={-3}
                        p={2}
                        mb={1}
                        textAlign="center" 
                        >
                            <MKTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                                Create Action
                            </MKTypography>
                        
                        </MKBox>
                
                        <MKBox pb={3} px={3}>
                            <MKBox display="flex" alignitems="center" justifyContent="space-between" p={2}>
                                <MKTypography variant="h5">Create action for application '{app.name}'</MKTypography> 
                                
                            </MKBox>
                            <MKBox display="flex" alignitems="center" justifyContent="space-between" px={2}>
                                <MKTypography variant="body2" color="text">Enter your action information</MKTypography>
                            </MKBox>
                            
                            <MKBox>
                                    
                                    {error && <MKTypography variant="button" color="error" px={2}>{error}</MKTypography> }
                                    {message && <MKTypography variant="body2" color="info" px={2}>{message}</MKTypography>}
                                    <Divider sx={{ my: 0 }} />
                                
                                    <MKBox p={2}>
                                        
                                        <MKBox mb={2} >

                                            <MKInput
                                                id="name"
                                                variant="standard"
                                                label="Name"
                                                value={data.name}
                                                onChange={onChangeInput}
                                                name="name"
                                                required
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 50 }}
                                                fullWidth
                                                /> 

                                            
                                            
                                        </MKBox>

                                        <MKBox  >

                                            <MKInput
                                                id="desc"
                                                variant="standard"
                                                label="Description"
                                                value={data.desc}
                                                onChange={onChangeInput}
                                                name="desc" 
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 250 }}
                                                fullWidth
                                                rows={3}
                                                multiline 
                                                onKeyDown = {onKeyEnterDown}
                                                /> 

                                           
                                         
                                        </MKBox>

                                    </MKBox>
                                    
                                    <Divider sx={{ my: 0 }} />
                                    
                                    <MKBox display="flex" justifyContent="space-between" p={1.5}>

                                        <MKButton variant="gradient" color="dark" onClick={() => toggleCreateActionModal()} >
                                            Close
                                        </MKButton>

                                        <MKButton variant="gradient" color="primary" onClick={() => handleCreateAction()}  >
                                            Submit
                                        </MKButton>

                                    </MKBox>
                                    
                                    
                                
                                </MKBox>
                        </MKBox>
                        
                        </Card>
                    </Grid>
                </Slide>
            </Modal> 




            <Modal open={modalState.showDeleteAction} onClose={toggleDeleteActionModal} sx={{ display: "grid", placeItems: "center" }}>
                <Slide direction="down" in={modalState.showDeleteAction} timeout={300}>
                    <MKBox
                    position="relative"
                    sx={{ maxWidth: 'md' }}
                    display="flex"
                    flexDirection="column"
                    borderRadius="xl"
                    bgColor="white"
                    shadow="xl"
                    >
                    <MKBox alignItems="center" p={2}>
                        <MKTypography variant="h5">Are you sure to delete this app action?</MKTypography>  
                    </MKBox> 
                    
                    <Divider sx={{ my: 0 }} />
                    <MKBox p={2}>
                        
                        <MKTypography variant="body">This transaction can't undo.</MKTypography>
                    </MKBox>
                    <Divider sx={{ my: 0 }} />
                    <MKBox display="flex" justifyContent="space-between" p={1.5}>
                        <MKButton variant="gradient" color="dark" onClick={toggleDeleteActionModal}>
                        cancel
                        </MKButton>
                        <MKButton variant="gradient" color="primary" onClick={deleteAppActionHandler}>
                        Submit
                        </MKButton>
                    </MKBox>
                    </MKBox>
                </Slide>
            </Modal> 
            
        </MKBox>


        }
        </MKBox>
    )
        
}
